import { ValidationError } from '@/components/validation-error/validation-error';
import { FieldErrors, SubmitErrorHandler } from 'react-hook-form';

export const createFormErrorHandler = <T extends Record<string, unknown>>(
  setValidationErrors: (errors: ValidationError[]) => void
): SubmitErrorHandler<T> => {
  return ((errors: FieldErrors<T>) => {
    const errorMessages: ValidationError[] = [];

    Object.entries(errors).forEach(([, error]) => {
      if (error?.message && typeof error.message === 'string') {
        errorMessages.push({
          messages: [error.message],
        });
      }
    });

    setValidationErrors(errorMessages);
  }) as SubmitErrorHandler<T>;
};
